import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import moment from 'moment';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FlexpassEvents extends Component {

    renderEvents = () => {
        if (this.props.events.length > 0) {
            return (
                <div className="table-responsive" style={{ height: 300 }}>
                    <table id="flexpassEventsTbl" className="showtix-table showtix-table__striped">
                        <thead>
                            <tr>
                                <th style={{ width: 20 }}>
                                    <div className="showtix-form__checkbox">
                                        <input
                                            type="checkbox"
                                            className="showtix-input"
                                            id="input-event-all"
                                            value="true"
                                            onChange={this.props.selectAllEventCheckboxes}
                                        />
                                        <label className="showtix-label" htmlFor="input-event-all"></label>
                                    </div>
                                </th>
                                <th>{strings.eventsTable.event}</th>
                                <th>{strings.eventsTable.dateAndTime}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.events.map((event, i) => {
                                    const displayedDate = (event.date != "") ? `${moment(event.date).format('dddd MMMM Do, YYYY')}` : "";
                                    const displayedTime = (event.date != "") ? `${moment(event.date).format('h:mm A')}` : "";
                                    const checked = (this.props.flexpassExists && this.props.selectedEvents.indexOf(event.id) != -1) ? true : false;
                                    return (
                                        <tr key={i}>
                                            <td style={{ width: 20 }}>
                                                <div className="showtix-form__checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="showtix-input"
                                                        id={"input-event-" + event.id}
                                                        value={event.id}
                                                        checked={this.props.selectedEvents.indexOf(event.id) != -1}
                                                        onChange={this.props.updateSelectedEvents}
                                                    />
                                                    <label className="showtix-label" htmlFor={"input-event-" + event.id}></label>
                                                </div>
                                            </td>
                                            <td>
                                                {event.name} 
                                            </td>
                                            <td>
                                                {displayedDate}<br />
                                                {displayedTime}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return (
                <p>{strings.noEvents}</p>
            );
        }
    }

    render() { 
        let buttonLabel = (this.props.flexpassExists) ? strings.updateBtn : strings.saveBtn;
        return ( 
            <div className={"showtix-section showtix-section__padding-1 showtix-background__primary-3 " + (this.props.events.length > 0 ? 'open' : 'collapsed')}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.title}</h1>
                            <h3>{strings.subTitle}</h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-lg-9 text-left">
                            { this.renderEvents() }
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 col-md-12">
                            <button 
                                className="showtix-button showtix-background__primary-1"
                                onClick={this.props.saveFlexpass}
                                disabled={!this.props.isReadyToSubmit}>
                                    {buttonLabel}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

FlexpassEvents.propTypes = {
    isReadyToSelectEvents: PropTypes.bool,
    events: PropTypes.array,
    selectAllEventCheckboxes: PropTypes.func,
    updateSelectedEvents: PropTypes.func,
    saveFlexpass: PropTypes.func
}
 
export default FlexpassEvents;


// WEBPACK FOOTER //
// ./src/components/CreateFlexpass/FlexpassEvents/FlexpassEvents.js